
import './Broucher.css';
function Broucher(){
    return(
        <>
        <div className="text-center mb-3">
            <div className="quote-page-stripe quote-page-stripe-second">
                <div className="d-flex align-items-center justify-content-center pl-lg-auto p-1">
                    <a
                        href='https://share.avhan.com/s/edepATwOILcSKAf'
                        id="ctl00_ctl00_MainContent_BenefitsMst_lnkBrochure"
                        target="_blank"
                        className="d-flex align-items-center"
                    >
                        <i className="icon icon-sm icon-download-white  float-left" />
                        <p className="ml-2 whatsapp-detail lato-bold font-weight-bold font-10 lh-10 text-white mb-0">
                            Download Brochure
                        </p>
                    </a>
                </div>
            </div>
        </div>

        

        
        </>
    )
}

export default Broucher;

